import React from 'react';

import { TextInput as TX, I18nManager } from 'react-native';
import { theme, style } from 'constants';
import { isWeb } from './platform';

const styles = style({
    input: {
        borderStyle: 'solid',
        backgroundColor: 'white',
        borderWidth: 1,
        borderRadius: 10,
        paddingHorizontal: 15,
        //  lineHeight: 50,
        height: 50,
        width: 300
    }
});

export const TextInput = ({ style, color, size, autoDir, ...props }) => {
    const Size = size || 16;
    const Color = color || theme.gray_color;
    const BoderColor = color || theme.gray_color_lighten();
    //const Icon = icon
    return (
        <TX
            underlineColorAndroid={'transparent'}
            style={[
                styles.input,
                { color: Color, borderColor: BoderColor, fontSize: Size, direction: autoDir ? 'auto' : I18nManager.isRTL ? 'rtl' : 'ltr' },
                isWeb && { outline: 'none' },
                style
            ]}
            {...props}
        />
    );
};



// WEBPACK FOOTER //
// ./src/components/core/textinput.js